"use client";

import type { Route } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";

import Icon from "@/components/icon";
import { NavLinks } from "@/TS/Interfaces/global_interfaces";

function MobileNavMore({ links }: { links: NavLinks[] }) {
  const pathname = usePathname();

  return (
    <div
      className={
        "bg-primary fixed grid grid-cols-2 grid-rows-5 gap-6 p-6 z-50 inset-0"
      }
    >
      {links.map(({ href, label, icon }, index: number) => {
        return (
          <div className={"flex"} key={index}>
            <Link
              key={icon}
              href={href as Route}
              className={`${pathname === href ? " text-primary font-bold" : ""} flex bg-white flex-col justify-center rounded-2xl w-full items-center hover:text-primary`}
              // onClick={}
            >
              <Icon icon={icon!} size={40}></Icon>
              <p className={"text-xl mt-1"}>{label}</p>
            </Link>
          </div>
        );
      })}
    </div>
  );
}

export default MobileNavMore;
